import _isFunction from 'lodash/isFunction';
import { EMPTY_OBJECT } from '../app.constants';

var getSectionHeight = function getSectionHeight(section, getHeight) {
  return _isFunction(getHeight) ? getHeight({
    section: section
  }) : section.offsetHeight;
};

export var bisection = function bisection(_ref) {
  var targetHeight = _ref.targetHeight,
      middleIndex = _ref.middleIndex,
      startIndex = _ref.startIndex,
      lastIndex = _ref.lastIndex,
      text = _ref.text,
      element = _ref.element,
      _ref$options = _ref.options,
      options = _ref$options === void 0 ? EMPTY_OBJECT : _ref$options;
  var getHeight = options.getHeight,
      _options$suffix = options.suffix,
      suffix = _options$suffix === void 0 ? '...' : _options$suffix;
  var mid = text.lastIndexOf(' ', middleIndex);
  var end = lastIndex;
  var begin = startIndex;
  var section = element;
  section.innerHTML = text.substring(0, mid) + suffix;
  var sectionHeight = getSectionHeight(section, getHeight);

  if (sectionHeight <= targetHeight) {
    section.innerHTML = text.substring(0, text.lastIndexOf(' ', mid + 1)) + suffix;
    sectionHeight = getSectionHeight(section, getHeight);

    if (sectionHeight > targetHeight || mid === begin) {
      return mid;
    }

    begin = mid;

    if (end - begin === 1) {
      mid = text.lastIndexOf(' ', 1 + begin);
    } else {
      mid = text.lastIndexOf(' ', Math.floor((end - begin) / 2) + begin);
    }

    return bisection({
      targetHeight: targetHeight,
      middleIndex: mid,
      startIndex: begin,
      lastIndex: end,
      text: text,
      element: section,
      options: options
    });
  }

  if (mid - 1 < 0) {
    return mid;
  }

  section.innerHTML = text.substring(0, text.lastIndexOf(' ', mid - 1)) + suffix;
  sectionHeight = getSectionHeight(section, getHeight);

  if (sectionHeight <= targetHeight) {
    return text.lastIndexOf(' ', mid - 1);
  }

  end = mid;
  mid = text.lastIndexOf(' ', Math.floor((end - begin) / 2) + begin);
  return bisection({
    targetHeight: targetHeight,
    middleIndex: mid,
    startIndex: begin,
    lastIndex: end,
    text: text,
    element: section,
    options: options
  });
};